import { createRouter, createWebHistory } from "vue-router";
import ListMandatos from "../views/Tables.vue";
import Profile from "../views/Profile.vue";
import Signup from "../views/Signup.vue";
import Login from "../views/login.vue";
import Password from "../views/Password.vue";
import Powerbi from "../views/Powerbi.vue";
import File from "../views/File.vue";

// Función para validar el token (puedes adaptarla según tu implementación)
function isAuthenticated() {
  const token = localStorage.getItem("token");
  // Aquí puedes agregar más lógica para validar el token, como verificar su expiración.
  return !!token;
}

const routes = [
  {
    path: "/",
    name: "Login",
    component: Login,
  },
  {
    path: "/dashboard",
    name: "Dashboard",
    component: ListMandatos,
    meta: { requiresAuth: true }, // Meta propiedad para proteger esta ruta
  },
  {
    path: "/perfil",
    name: "Perfil",
    component: Profile,
    meta: { requiresAuth: true }, // Protección de esta ruta
  },
  {
    path: "/code",
    name: "Code",
    component: Signup,
  },
  {
    path: "/password",
    name: "Password",
    component: Password,
  },
  {
    path: "/reset-password",
    name: "reset-Password",
    component: Password,
  },
  {
    path: "/powerbi",
    name: "Powerbi",
    component: Powerbi,
    meta: { requiresAuth: true }, // Protección de esta ruta
  },
  {
    path: "/documentos",
    name: "Document",
    component: File,
    meta: { requiresAuth: true }, // Protección de esta ruta
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  linkActiveClass: "active",
});

// Guarda global para proteger rutas
router.beforeEach((to, from, next) => {
  if (to.meta.requiresAuth && !isAuthenticated()) {
    // Si la ruta requiere autenticación y no hay token, redirige al login
    next({ name: "Login" });
  } else {
    // Permite el acceso a la ruta
    next();
  }
});

export default router;
